// extracted by mini-css-extract-plugin
export default {"bar":"FeaturesBar_bar__F-Oz-","inner":"FeaturesBar_inner__gLLA9","item":"FeaturesBar_item__wUCkE","icon":"FeaturesBar_icon__sM2pT","label":"FeaturesBar_label__tJMJm"};